module.exports = __webpack_public_path__ + "static/media/query-trucks@2x.1c93e07f.jpg";